<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">Picture Perf*cked</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005">Chapter One: Getting to Know Myself</a></li>
<li id="toc-li-6"><a href="#/text/ch006">Chapter Two: Ladies Who Brunch</a></li>
<li id="toc-li-7"><a href="#/text/ch007">Chapter Three: Smoke ’N Mirrors</a></li>
<li id="toc-li-8"><span href="#/text/ch008" title="Link target outside of Sample">Chapter Four: Accepting Adulthood</span>
<ol class="toc">
<li id="toc-li-9"><span href="#/text/ch008#defining-adulthood" title="Link target outside of Sample">1. Defining Adulthood</span></li>
<li id="toc-li-10"><span href="#/text/ch008#failure" title="Link target outside of Sample">2. Failure</span></li>
<li id="toc-li-11"><span href="#/text/ch008#we-are-all-in-this-together" title="Link target outside of Sample">3. We Are All in This
                        Together</span></li>
<li id="toc-li-12"><span href="#/text/ch008#people-pleaser" title="Link target outside of Sample">4. People Pleaser</span></li>
<li id="toc-li-13"><span href="#/text/ch008#no-one-has-it-all" title="Link target outside of Sample">5. No One Has It All</span></li>
</ol>
</li>
<li id="toc-li-14"><span href="#/text/ch009" title="Link target outside of Sample">Chapter Five: The Fuckery Called Expectations</span></li>
<li id="toc-li-15"><span href="#/text/ch010" title="Link target outside of Sample">Chapter Six: Shit Happens</span></li>
<li id="toc-li-16"><span href="#/text/ch011" title="Link target outside of Sample">Chapter Seven: Let’s Talk About Sex (and Trying to Have a)
                Baby!</span></li>
<li id="toc-li-17"><span href="#/text/ch012" title="Link target outside of Sample">Chapter Eight: C’est La Vie Mum Life</span>
<ol class="toc">
<li id="toc-li-18"><span href="#/text/ch012#the-birthing" title="Link target outside of Sample">1. The Birthing</span></li>
<li id="toc-li-19"><span href="#/text/ch012#parenthoodthe-early-days" title="Link target outside of Sample">2. Parenthood—The Early Days</span>
</li>
<li id="toc-li-20"><span href="#/text/ch012#mum-guilt" title="Link target outside of Sample">3. Mum Guilt</span></li>
</ol>
</li>
<li id="toc-li-21"><span href="#/text/ch013" title="Link target outside of Sample">Chapter Nine: When Life Hits You Sideways</span></li>
<li id="toc-li-22"><span href="#/text/ch014" title="Link target outside of Sample">Chapter Ten: Into the Thick of It</span>
<ol class="toc">
<li id="toc-li-23"><span href="#/text/ch014#what-ppd-felt-like-for-me" title="Link target outside of Sample">1. What PPD Felt Like for
                        Me:</span></li>
<li id="toc-li-24"><span href="#/text/ch014#staying-quiet" title="Link target outside of Sample">2. Staying Quiet:</span></li>
</ol>
</li>
<li id="toc-li-25"><span href="#/text/ch015" title="Link target outside of Sample">Chapter Eleven: To-Do (It All) Lists</span></li>
<li id="toc-li-26"><span href="#/text/ch016" title="Link target outside of Sample">Chapter Twelve: Whoosah!</span></li>
<li id="toc-li-27"><span href="#/text/ch017" title="Link target outside of Sample">Chapter Thirteen: Saving the Drama</span></li>
<li id="toc-li-28"><span href="#/text/ch018" title="Link target outside of Sample">Chapter Fourteen: Tis the Fucking Season</span></li>
<li id="toc-li-29"><span href="#/text/ch019" title="Link target outside of Sample">Chapter Fifteen: Finding the Funny in Failure</span></li>
<li id="toc-li-30"><span href="#/text/ch020" title="Link target outside of Sample">Chapter Sixteen: Oh…That ‘Ah-Ha’ Moment</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?7bb75f96